import {
  Earning_Mechanism_Product_Counting_Attribute,
  Earning_Mechanism_Product_Counting_Rounding_Strategy,
} from '@occc/graphql';

type ProductCountingMap = {
  [key in Earning_Mechanism_Product_Counting_Attribute]: string;
};
const productCountingMap: ProductCountingMap = {
  [Earning_Mechanism_Product_Counting_Attribute.MoneyAmount]: 'Money amount',
  [Earning_Mechanism_Product_Counting_Attribute.Quantity]: 'Quantity',
  [Earning_Mechanism_Product_Counting_Attribute.UnitsCount]: 'Units count',
};
export const formatProductCounting = ({
  countProductsBy,
}: {
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute;
}): string => productCountingMap[countProductsBy];

type ProductRoundingMap = {
  [key in Earning_Mechanism_Product_Counting_Rounding_Strategy]: string;
};
const productRoundingMap: ProductRoundingMap = {
  [Earning_Mechanism_Product_Counting_Rounding_Strategy.Down]: 'Down',
  [Earning_Mechanism_Product_Counting_Rounding_Strategy.HalfUp]: 'Half up',
  [Earning_Mechanism_Product_Counting_Rounding_Strategy.Raw]: 'No rounding will be applied',
};
export const formatProductRounding = ({
  roundCountedProducts,
}: {
  roundCountedProducts: Earning_Mechanism_Product_Counting_Rounding_Strategy;
}): string => productRoundingMap[roundCountedProducts];
